<template>
    <div id="date-picker">
        <popper
            trigger="clickToToggle"
            :prevent-default="true"
            :options="{
                placement: 'bottom',
            }"  
            ref="popper"
        >
            <div class="popper">
                <CoreDatePicker 
                    v-model="proxy" 
                    :bookings="bookings"
                    :columns="$screens({ default: 1, lg: 2 })"
                    :rows="$screens({ default: 1})"   
                ></CoreDatePicker>
                <div class="row" style="padding-bottom: 10px;">
                    <div class="col" style="text-align: left">
                        <button class="btn btn-outline-primary" @click.prevent="clearSelection">{{ $t('common.actions.clear') }}</button>
                    </div>
                    <div class="col" style="text-align: right">
                        <button class="btn btn-primary" @click.prevent="closePopup">{{ $t('common.actions.close') }}</button>
                    </div>
                </div>
            </div>
            <!-- The trigger element will be injected here -->
            <slot slot="reference"></slot>
        </popper>
    </div>
</template>

<script>
import Popper from 'vue-popperjs';
import 'vue-popperjs/dist/vue-popper.css';
import CoreDatePicker from "@/components/common/datepicker/CoreDatePicker.vue";
export default {
    name: "PopperDatePicker",
    components: {
        Popper, 
        CoreDatePicker
    },
    props: {
        selectedDates: {
            type: Object,
            required: true,
            default: () => {}
        },
        bookings: {
            type: Array,
            required: false,
            default: () => [] // Use an empty array
        },
    },
    computed: {
        proxy: {
            get() {
                console.log("[DatePicker] - Getting value")
                return this.selectedDates;
            },
            set(val) {
                console.log("[DatePicker] - Setting new value")

                this.$emit("update:selectedDates", val);
            }
        }
    },
    methods: {
        clearSelection: function() {
            // this.$set(this.selectedDate, 'start', undefined)
            // this.$set(this.selectedDate, 'end', undefined)

            this.proxy = {
                start: undefined,
                end: undefined
            }
        },
        closePopup: function() {
            this.$refs['popper'].doClose();
        }
    }
}
</script>

<style lang="scss" scoped>
    $border-radius: 5px;

    .popper {
        background-color: white;
    }
    .vc-border {
        border-width: 0;
    }

    .vc-border, .vc-border-2, .vc-border-3 {
        border-style: unset;
    }


    .btn {
        border-radius: $border-radius;
    }

    .btn-outline-primary {
        background-color: transparent !important;
        border-color: $primary-color !important;
        color: $primary-color !important;
        
    }
    .btn-outline-primary.active.show {
        background-color: $primary-color !important;
        color: white !important;
    }

</style>